(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["base-text-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initDoc(root) {
    if (root.dataset.hkInit === 'true') return;
    root.dataset.hkInit = 'true';

    var content = root.querySelector('[data-hk-content]');
    if (!content) return;
    var nav = root.querySelector('[data-hk-nav]');
    var toc = root.querySelector('[data-hk-toc]');
    var progress = root.querySelector('[data-hk-progress]');
    var topBtn = root.querySelector('[data-hk-top]');
    var readtime = root.querySelector('[data-hk-readtime]');

    if (readtime) {
      var words = content.innerText.trim().split(/\s+/).length;
      readtime.textContent = Math.max(1, Math.round(words / 200)) + ' min';
    }

    // Wrap tables so they scroll on mobile
    content.querySelectorAll('table').forEach(function (t) {
      if (t.parentElement.classList.contains('hk-doc__table-wrap')) return;
      var w = document.createElement('div');
      w.className = 'hk-doc__table-wrap';
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
    });

    var headings = content.querySelectorAll('h2, h3');
    var slugs = {};

    headings.forEach(function (h) {
      if (!h.id) {
        var s = h.textContent.toLowerCase().replace(/[^\w\s-]/g, '').trim().replace(/\s+/g, '-');
        slugs[s] = (slugs[s] || 0) + 1;
        h.id = slugs[s] > 1 ? s + '-' + slugs[s] : s;
      }
      if (h.tagName === 'H2') {
        var anchor = document.createElement('a');
        anchor.className = 'hk-doc__anchor';
        anchor.href = '#' + h.id;
        anchor.setAttribute('aria-label', 'Link to this section');
        anchor.textContent = '#';
        h.appendChild(anchor);
      }
      if (!toc) return;
      var li = document.createElement('li');
      if (h.tagName === 'H3') li.className = 'is-sub';
      var link = document.createElement('a');
      link.href = '#' + h.id;
      link.textContent = h.firstChild ? h.firstChild.textContent : h.textContent;
      li.appendChild(link);
      toc.appendChild(li);
    });

    var links = toc ? toc.querySelectorAll('a') : [];

    if (toc && 'IntersectionObserver' in window) {
      var seen = new Map();
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { seen.set(e.target.id, e.isIntersecting); });
        var activeId = null;
        headings.forEach(function (h) { if (seen.get(h.id) && !activeId) activeId = h.id; });
        if (!activeId) return;
        links.forEach(function (l) {
          l.setAttribute('aria-current', l.getAttribute('href') === '#' + activeId ? 'true' : 'false');
        });
      }, { rootMargin: '-96px 0px -70% 0px' });
      headings.forEach(function (h) { obs.observe(h); });
    }

    function onScroll() {
      if (progress) {
        var rect = content.getBoundingClientRect();
        var total = rect.height - window.innerHeight * 0.4;
        var done = Math.min(Math.max(-rect.top + window.innerHeight * 0.4, 0), total);
        progress.style.height = (total > 0 ? (done / total) * 100 : 0) + '%';
      }
      if (topBtn) topBtn.classList.toggle('is-visible', window.scrollY > 600);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();

    if (topBtn) {
      topBtn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    if (nav) {
      var toggle = nav.querySelector('.hk-doc__nav-toggle');
      if (toggle) {
        toggle.addEventListener('click', function () {
          var open = nav.getAttribute('data-open') === 'true';
          nav.setAttribute('data-open', String(!open));
          toggle.setAttribute('aria-expanded', String(!open));
        });
        nav.addEventListener('click', function (e) {
          if (e.target.tagName === 'A' && window.innerWidth <= 900) {
            nav.setAttribute('data-open', 'false');
            toggle.setAttribute('aria-expanded', 'false');
          }
        });
      }
    }
  }

  function initAll() {
    document.querySelectorAll('[data-hk-doc]').forEach(initDoc);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  if (document.readyState !== 'loading') initAll();
  // Theme editor: re-init when the section is reloaded
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-hk-doc]').forEach(initDoc);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-navigation-v2"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.info__section__swiper', {
    slidesPerView: 1,
    spaceBetween: 20,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-navigation"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.info__section__swiper', {
    slidesPerView: 1,
    spaceBetween: 20,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["google-review"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('#google__review__gallary', {
    spaceBetween: 30,
    autoplay: { delay: 6500, disableOnInteraction: false },
    breakpoints: { 640: { slidesPerView: 2, spaceBetween: 20 }, 768: { slidesPerView: 2, spaceBetween: 20 } },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-custom"]) return;
  try {
    
  // Select elements with class feather-x and add hideIcon class
  document.querySelectorAll('.feather.feather-x').forEach(function (element) {
    element.classList.add('hideIcon');
  });

  // Function to toggle classes and handle body scroll
  function toggleNavbar() {
    document
      .querySelectorAll('.mobile__navbar__showcase, .mobile__navbar__showcase_shadow')
      .forEach(function (element) {
        element.classList.toggle('drawer__show');
      });

    var drawerShow = document.querySelectorAll('.mobile__navbar__showcase.drawer__show').length > 0;

    if (drawerShow) {
      document.body.style.overflow = 'hidden'; // Disable body scroll
    } else {
      document.body.style.overflow = ''; // Restore whatever the page's own stylesheet wants
    }

    document.querySelector('.feather.feather-menu').classList.toggle('hideIcon');
    document.querySelector('.feather.feather-x').classList.toggle('hideIcon');
  }

  // Add click event listener to toggler elements
  document.querySelectorAll('.navbar-toggler, .mobile-nav-custom-close').forEach(function (element) {
    element.addEventListener('click', toggleNavbar);
  });

  // Add click event listener to mobile navbar shadow
  document.querySelector('.mobile__navbar__showcase_shadow').addEventListener('click', toggleNavbar);

  // Close the drawer with the Escape key
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && document.querySelector('.mobile__navbar__showcase.drawer__show')) {
      toggleNavbar();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["intro-with-video-background"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.swiper__brands', {
    loop: true,
    speed: 2000,
    slidesPerView: 6,
    spaceBetween: 10,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      300: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      375: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      425: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      540: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      640: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 6,
        spaceBetween: 10,
      },
      1300: {
        slidesPerView: 6,
        spaceBetween: 10,
      },
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-carousel"] && !Shopify.designMode) return;
  try {
    
  var swiper_lc = new Swiper('.logoCarousel__section__wrapper .swiper__brands', {
    loop: true,
    speed: 2000,
    slidesPerView: 6,
    spaceBetween: 10,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      300: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      375: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      425: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      540: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      640: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
      1024: {
        slidesPerView: 6,
        spaceBetween: 10,
      },
      1300: {
        slidesPerView: 6,
        spaceBetween: 10,
      },
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-custom"]) return;
  try {
    
  jQuery(document).ready(function () {
    // script for updating mini cart items
    jQuery('.cart__details__minus__button')
      .off('click')
      .click(async function () {
        let itemId = jQuery(this).closest('.cart__details__large__content').data('product-key');
        let itemQuantity = parseInt(jQuery(this).siblings('.cart__details__current__quantity').text());

        if (itemQuantity > 1) {
          itemQuantity--;
          jQuery(this).siblings('.cart__details__current__quantity').text(itemQuantity);
          
          // Update button state immediately
          if (itemQuantity <= 1) {
            jQuery(this).attr('disabled', 'disabled');
          }
          
          await updateCart(itemId, itemQuantity);
        }
      });

    jQuery('.cart__details__plus__button')
      .off('click')
      .click(async function () {
        let itemId = jQuery(this).closest('.cart__details__large__content').data('product-key');
        let itemQuantity = parseInt(jQuery(this).siblings('.cart__details__current__quantity').text());

        itemQuantity++;
        jQuery(this).siblings('.cart__details__current__quantity').text(itemQuantity);
        
        // Update minus button state immediately (enable it since quantity is now > 1)
        let minusButton = jQuery(this).siblings('.cart__details__minus__button');
        if (minusButton.length && itemQuantity > 1) {
          minusButton.removeAttr('disabled');
        }
        
        await updateCart(itemId, itemQuantity);
      });

    // update cart item quantity with AJAX
    let requestInProgress = false;

    async function updateCart(itemId, itemQuantity) {
      if (requestInProgress) {
        return Promise.reject('Request already in progress');
      }

      requestInProgress = true;

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            updates: {
              [itemId]: itemQuantity,
            },
          }),
        });

        if (!response.ok) {
          throw new Error('Cart update failed: ' + response.statusText);
        }

        const cart = await response.json();

        if (cart) {
          const cartUpdatedEvent = new CustomEvent('cart:updated', {
            detail: {
              cart: cart,
            },
          });
          window.dispatchEvent(cartUpdatedEvent);
          return cart;
        } else {
          throw new Error('Cart update failed: unknown error');
        }
      } catch (error) {
        console.error('Cart update failed:', error);
        throw error;
      } finally {
        requestInProgress = false;
      }
    }

    jQuery('.cart__details__large__remove__btn')
      .off('click')
      .click(async function () {
        let itemId = jQuery(this).closest('[data-item-id]').data('item-id');
        await removeItemFromCart(itemId);
        jQuery(this).closest('[data-item-id]').remove(); // remove cart item content from DOM
      });

    // remove cart item with AJAX
    async function removeItemFromCart(itemId) {
      let data = {};
      data[itemId] = 0;

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            updates: data,
          }),
        });

        if (!response.ok) {
          throw new Error('Cart update failed: ' + response.statusText);
        }

        const cart = await response.json();

        if (cart) {
          const cartUpdatedEvent = new CustomEvent('cart:updated', {
            detail: {
              cart: cart,
            },
          });
          window.dispatchEvent(cartUpdatedEvent);
          validateCheckoutRequirements();
          return cart;
        } else {
          throw new Error('Cart update failed: unknown error');
        }
      } catch (error) {
        console.error('Cart update failed:', error);
        throw error;
      }
    }

    window.addEventListener('cart:updated', function (event) {
      const data = event.detail;
      if ('{{membershipPricingAvailable}}' === 'true') {
        window.location.reload();
      }

      let cartSubtotalPrice = data.cart.items_subtotal_price / 100;
      let cartFormattedPrice = '$' + cartSubtotalPrice.toFixed(2);
      document.querySelector('.cart__details__large__footer__price').textContent = cartFormattedPrice;

      if (data.cart && data.cart.items) {
        data.cart.items.forEach((itemInfo) => {
          let ajaxUpdatePrice = document.querySelector('[data-ajax-update-price="' + itemInfo.key + '"]');
          let ajaxUpdateQuantity = document.querySelector('[data-ajax-update-quantity="' + itemInfo.key + '"]');
          if (ajaxUpdatePrice && ajaxUpdateQuantity) {
            let itemPrice = itemInfo.final_line_price / 100; // divide by 100 to convert to dollars
            let formattedItemPrice = '$' + itemPrice.toFixed(0);
            ajaxUpdatePrice.textContent = formattedItemPrice;
            ajaxUpdateQuantity.textContent = itemInfo.quantity;
            
            // Find the minus button for this item and update its disabled state
            let cartContent = ajaxUpdateQuantity.closest('.cart__details__large__content');
            if (cartContent) {
              let minusButton = cartContent.querySelector('.cart__details__minus__button');
              if (minusButton) {
                if (itemInfo.quantity <= 1) {
                  minusButton.setAttribute('disabled', 'disabled');
                } else {
                  minusButton.removeAttribute('disabled');
                }
              }
            }
          }
        });
      } else {
        console.log('Cart items not found in data:', data);
      }

      // Display logic for content and empty cart
      const cartDetailsWrapper = document.querySelector('.cart__details__wrapper');
      const cartEmptyWrapper = document.querySelector('.cart__empty__wrapper');
      const cartUpsellWrapper = document.querySelector('.cart__upsell__wrapper');

      if (data.cart.item_count === 0) {
        if (cartDetailsWrapper) {
          cartDetailsWrapper.style.display = 'none';
        }
        if (cartEmptyWrapper) {
          cartEmptyWrapper.style.display = 'block';
        }
        if (cartUpsellWrapper) {
          cartUpsellWrapper.style.display = 'none';
        }
      }
    });

 

    // Self-Executing Anonymous Function
    (function () {
      console.log('prefix js is running');
      const endpoint = '/cart.js';
      jQuery.ajax({
        url: endpoint,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
          if (data.item_count === 0) {
            console.log('The cart is empty.');
            jQuery('.cart__details__wrapper').css('display', 'none');
            if (jQuery('.cart__upsell__wrapper')[0]) {
              jQuery('.cart__upsell__wrapper').css('display', 'none');
            }
          } else {
            jQuery('.cart__empty__wrapper').css('display', 'none');
            if (jQuery('.cart__upsell__wrapper')[0]) {
              jQuery('.cart__upsell__wrapper').css('display', 'block');
            }
          }
        },
        error: function (xhr, status, error) {
          console.error('Error:', error);
        },
      });
    })();
    
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-grid"]) return;
  try {
    
  (function () {
    if (window.gridCartReady) return;
    window.gridCartReady = true;

    const SECTION = '[data-grid-cart]';

    function closest(target, selector) {
      return target && target.closest ? target.closest(selector) : null;
    }

    function activeIndex(root) {
      const active = root.querySelector('[data-pill].is-active');
      return active ? Number(active.dataset.pill) : 0;
    }

    function markActive(root, index) {
      root.querySelectorAll('[data-pill]').forEach((pill) => {
        const isActive = Number(pill.dataset.pill) === index;
        pill.classList.toggle('is-active', isActive);
        pill.setAttribute('aria-selected', String(isActive));
        pill.tabIndex = isActive ? 0 : -1;
        if (isActive) reveal(pill);
      });

      root.querySelectorAll('[data-dot]').forEach((dot) => {
        dot.classList.toggle('is-active', Number(dot.dataset.dot) === index);
      });
    }

    function select(root, index) {
      markActive(root, index);

      root.querySelectorAll('[data-pane]').forEach((pane) => {
        const isActive = Number(pane.dataset.pane) === index;
        pane.classList.toggle('is-active', isActive);
        pane.hidden = !isActive;
      });

      /* Tracks rarely have the same number of days, so the mobile slide has
         to be measured again against its new content. */
      const pager = root.querySelector('cart-pager');
      if (pager && pager.fit) pager.fit();

      /* Scaling a slide changes how wide the scrollers are, so which arrows
         a row needs can only be settled once the fit has been applied. */
      refreshSliders(root);
    }

    /* Centres a control inside its own scroller without scrolling the page,
       which scrollIntoView would do on the ancestors too. */
    function reveal(item) {
      const row = item.parentElement;
      if (!row || row.scrollWidth - row.clientWidth < 2) return;

      const left = item.offsetLeft - (row.clientWidth - item.offsetWidth) / 2;
      row.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    }

    function updateSlider(track) {
      const max = track.scrollWidth - track.clientWidth;
      const overflowing = max > 4;
      const atStart = track.scrollLeft <= 4;
      const atEnd = track.scrollLeft >= max - 4;

      track.classList.toggle('is-overflowing', overflowing);
      track.classList.toggle('at-start', atStart);
      track.classList.toggle('at-end', atEnd);

      /* Only the track's own siblings are considered: a scroller can sit
         inside a panel that holds other scrollers, and a descendant search
         would let one row drive another row's arrows. */
      const row = track.parentElement;
      if (!row) return;

      Array.prototype.forEach.call(row.children, (child) => {
        const direction = child.getAttribute && child.getAttribute('data-swipe');
        if (!direction) return;
        child.hidden = !overflowing || (direction === 'prev' ? atStart : atEnd);
      });
    }

    function refreshSliders(scope) {
      (scope || document).querySelectorAll('[data-chips]').forEach(updateSlider);
    }

    /* Native `behavior: 'smooth'` runs a short fixed glide that snapping then
       corrects at the end, which is what reads as a stop rather than a
       settle. Driving it here buys a longer ease and lets snapping stand
       down until the row has come to rest. */
    const GLIDE_MS = 420;

    function glide(track, to) {
      const from = track.scrollLeft;
      const distance = to - from;
      if (Math.abs(distance) < 1) return;

      if (track.gliding) cancelAnimationFrame(track.gliding);
      track.style.scrollSnapType = 'none';

      const started = performance.now();
      const frame = (now) => {
        const progress = Math.min((now - started) / GLIDE_MS, 1);
        /* Ease out cubic: leaves at speed, arrives without a jolt. */
        track.scrollLeft = from + distance * (1 - Math.pow(1 - progress, 3));

        if (progress < 1) {
          track.gliding = requestAnimationFrame(frame);
          return;
        }

        track.gliding = null;
        track.style.scrollSnapType = '';
      };

      track.gliding = requestAnimationFrame(frame);
    }

    /* Where the row would have to sit for `child` to start flush against the
       left edge — the same place snapping would pick, worked out up front so
       a page never finishes mid-chip. */
    function chipOffset(track, child) {
      return track.scrollLeft + child.getBoundingClientRect().left - track.getBoundingClientRect().left - track.clientLeft;
    }

    function pageChips(track, back) {
      const limit = track.scrollWidth - track.clientWidth;
      /* A press turns the row over a full screenful. Landing on a chip edge
         below keeps a partly shown chip from being cut, which is the job the
         old fractional step was doing at the cost of barely moving. */
      const step = Math.max(track.clientWidth, 160);
      const target = Math.max(0, Math.min(back ? track.scrollLeft - step : track.scrollLeft + step, limit));

      /* Finishing flush against a chip is tidier, and leaves snapping nothing
         to correct once the row settles. It only applies when an edge is
         already near where the press was heading: a chip can be wider than
         the row it sits in, and nudging to the far side of one would either
         overshoot the press or put its middle out of reach entirely. Both
         ends are left alone so the last chip stays reachable. */
      let landing = target;

      if (target > 0 && target < limit) {
        let nearest = step * 0.35;
        Array.prototype.forEach.call(track.children, (child) => {
          const offset = chipOffset(track, child);
          const gap = Math.abs(offset - target);
          if (gap < nearest) {
            nearest = gap;
            landing = offset;
          }
        });
      }

      glide(track, Math.max(0, Math.min(landing, limit)));
    }

    function goToLogin(root) {
      const field = root.querySelector('[data-login-email]');
      const url = new URL(root.dataset.loginUrl || '/account/login', window.location.origin);
      url.searchParams.set('checkout_url', window.location.pathname);
      if (field && field.value) url.searchParams.set('email', field.value);
      window.location.assign(url.toString());
    }

    function setBusy(isBusy) {
      const root = document.querySelector(SECTION);
      if (!root) return;

      root.setAttribute('aria-busy', String(isBusy));
      const status = root.querySelector('.grid-cart__status');
      if (status) status.hidden = !isBusy;
    }

    async function rerender(root) {
      const index = activeIndex(root);
      const response = await fetch(`${window.location.pathname}?section_id=${root.dataset.sectionId}`);
      if (!response.ok) throw new Error(window.cartStrings.error);

      const next = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector(SECTION);
      if (!next) throw new Error(window.cartStrings.error);

      root.innerHTML = next.innerHTML;
      if (root.querySelector(`[data-pill="${index}"]`)) select(root, index);
      refreshSliders(root);
    }

    async function publish() {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`);
      if (!response.ok) return;

      const cart = await response.json();
      window.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      if (typeof window.miniCartCallback === 'function') window.miniCartCallback(false);
    }

    async function request(root, url, body) {
      setBusy(true);

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });

        if (!response.ok) throw new Error(window.cartStrings.error);

        await rerender(root);
        await publish();
      } catch (error) {
        window.alert(error.message || window.cartStrings.error);
      } finally {
        setBusy(false);
      }
    }

    let drag = null;
    let dragged = false;

    document.addEventListener('pointerdown', (event) => {
      dragged = false;

      const track = closest(event.target, '[data-chips]');
      if (!track || event.pointerType !== 'mouse' || event.button !== 0) return;
      if (track.scrollWidth - track.clientWidth < 2) return;
      /* Capturing the pointer retargets the click at the track, so a press that
         starts on a control would never reach that control's handler. */
      if (closest(event.target, 'button, a, input, select, textarea, label')) return;

      /* A grab takes the row off the arrows: leaving the glide running would
         have the two fight over scrollLeft frame by frame. */
      if (track.gliding) {
        cancelAnimationFrame(track.gliding);
        track.gliding = null;
        track.style.scrollSnapType = '';
      }

      drag = { track: track, startX: event.clientX, startLeft: track.scrollLeft };
      track.setPointerCapture(event.pointerId);
    });

    document.addEventListener('pointermove', (event) => {
      if (!drag) return;

      const distance = event.clientX - drag.startX;
      if (!dragged && Math.abs(distance) < 4) return;

      dragged = true;
      drag.track.classList.add('is-dragging');
      drag.track.scrollLeft = drag.startLeft - distance;
      event.preventDefault();
    });

    function endDrag() {
      if (!drag) return;
      drag.track.classList.remove('is-dragging');
      drag = null;
    }

    document.addEventListener('pointerup', endDrag);
    document.addEventListener('pointercancel', endDrag);

    document.addEventListener(
      'click',
      (event) => {
        if (!dragged || !closest(event.target, '[data-chips]')) return;
        dragged = false;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );

    document.addEventListener('click', (event) => {
      const root = closest(event.target, SECTION);
      if (!root) return;

      const swipe = closest(event.target, '[data-swipe]');
      if (swipe) {
        /* An arrow flanks the row it moves, so the track is read from the
           shared parent rather than an adjacent node. */
        const row = swipe.parentElement;
        const track = row && row.querySelector('[data-chips]');
        if (track) pageChips(track, swipe.getAttribute('data-swipe') === 'prev');
        return;
      }

      const pill = closest(event.target, '[data-pill]');
      if (pill) {
        select(root, Number(pill.dataset.pill));
        return;
      }

      const dot = closest(event.target, '[data-dot]');
      if (dot) {
        select(root, Number(dot.dataset.dot));
        return;
      }

      const remove = closest(event.target, '[data-remove-line]');
      if (remove) {
        request(root, window.routes.cart_change_url, {
          id: closest(remove, '[data-cart-item]').dataset.key,
          quantity: 0
        });
        return;
      }

      const step = closest(event.target, '[data-quantity-change]');
      if (step) {
        const line = closest(step, '[data-cart-item]');
        const current = Number(line.querySelector('[data-quantity-value]').textContent.trim());
        request(root, window.routes.cart_change_url, {
          id: line.dataset.key,
          quantity: Math.max(0, current + Number(step.dataset.quantityChange))
        });
        return;
      }

      const add = closest(event.target, '[data-add-variant]');
      if (add) {
        request(root, window.routes.cart_add_url, {
          items: [{ id: Number(add.dataset.addVariant), quantity: 1 }]
        });
        return;
      }

      if (closest(event.target, '[data-login-continue]')) {
        goToLogin(root);
        return;
      }

      if (closest(event.target, '[data-continue-guest]')) {
        request(root, window.routes.cart_update_url, { attributes: { guest_chosen: 'true' } });
        return;
      }
    });

    document.addEventListener('change', (event) => {
      const amount = event.target;
      if (!amount.matches || !amount.matches('.grid-cart__amount input')) return;

      const card = closest(amount, '.grid-cart__addon');
      const add = card && card.querySelector('[data-add-variant]');
      const price = card && card.querySelector('[data-amount-value]');
      if (add) add.dataset.addVariant = amount.value;
      if (price) price.textContent = amount.dataset.amountPrice;
    });

    document.addEventListener('keydown', (event) => {
      const root = closest(event.target, SECTION);
      if (!root) return;

      if (event.key === 'Enter' && closest(event.target, '[data-login-email]')) {
        event.preventDefault();
        goToLogin(root);
        return;
      }

      const pill = closest(event.target, '[data-pill]');
      if (!pill) return;

      const offset = { ArrowRight: 1, ArrowLeft: -1 }[event.key];
      if (!offset) return;

      event.preventDefault();
      const pills = Array.from(root.querySelectorAll('[data-pill]'));
      const next = (Number(pill.dataset.pill) + offset + pills.length) % pills.length;
      select(root, next);
      pills[next].focus();
    });

    document.addEventListener(
      'scroll',
      (event) => {
        const track = event.target;
        if (!track || !track.classList) return;
        if (track.hasAttribute && track.hasAttribute('data-chips')) updateSlider(track);
      },
      true
    );

    window.addEventListener('resize', () => refreshSliders());
    document.addEventListener('shopify:section:load', () => refreshSliders());
    refreshSliders();
  })();

  (function () {
    if (customElements.get('cart-pager')) return;

    const MOBILE = '(max-width: 989px)';
    /* Text shrunk further than this gets hard to read on a phone, so a
       slide that needs more scrolls instead. */
    const MIN_FIT = 0.85;
    const SWIPE_ICON =
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
      '<path d="M3 12h18M7 8l-4 4 4 4M17 8l4 4-4 4" stroke="currentColor" stroke-width="2.5" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>';

    let lastPane = 0;

    /* The fade at the foot of a scrolling slide hints at more below, and
       lifts once the end is in view. */
    function markPaneEnd(pane) {
      pane.classList.toggle('at-end', pane.scrollTop + pane.clientHeight >= pane.scrollHeight - 2);
    }

    /* Only an element that really scrolls sideways claims a swipe. Content
       that merely pokes past its box (the chip badges do, by a few pixels)
       also makes scrollWidth exceed clientWidth, so overflow is checked too. */
    function scrollerBetween(node, stop) {
      let el = node;
      while (el && el !== stop) {
        if (el.scrollWidth - el.clientWidth > 2 && /auto|scroll/.test(getComputedStyle(el).overflowX)) return el;
        el = el.parentElement;
      }
      return null;
    }

    class CartPager extends HTMLElement {
      connectedCallback() {
        this.media = window.matchMedia(MOBILE);
        this.onMedia = () => this.sync();
        this.onResize = () => this.measure();
        this.media.addEventListener('change', this.onMedia);
        window.addEventListener('resize', this.onResize);
        this.sync();
      }

      disconnectedCallback() {
        this.media.removeEventListener('change', this.onMedia);
        window.removeEventListener('resize', this.onResize);
        if (this.observer) this.observer.disconnect();
      }

      /* The app-shell height is the viewport minus whatever sits above the
         section (header, announcement bar) and minus the fixed checkout bar.
         Neither is knowable in CSS, so both are published as custom
         properties on the section root. */
      measure() {
        const root = this.closest('[data-grid-cart]');
        if (!root || !this.media.matches || !this.view) return;

        const bar = this.querySelector('.grid-cart__bar');

        /* Zero the offset first: the section is sized from it, so measuring
           while a stale value applies would feed the old number back in. */
        root.style.setProperty('--gc-viewport-offset', '0px');
        const top = Math.round(root.getBoundingClientRect().top + window.scrollY);

        root.style.setProperty('--gc-viewport-offset', Math.max(0, top) + 'px');
        if (bar) root.style.setProperty('--gc-bar-height', bar.offsetHeight + 'px');
        root.setAttribute('data-app-shell', '');
        this.fit();
      }

      /* A slide taller than its pane is scaled down, but only as far as
         MIN_FIT; anything taller still (a long run of booked days) scrolls
         inside its pane at that scale rather than shrinking past the point of
         being readable. Scaling widens the content by the same factor first,
         so the cards re-wrap and the shrink is smaller than a naive ratio. */
      fit() {
        if (!this.fitters) return;

        this.fitters.forEach((fitter, index) => {
          const pane = this.panes[index];
          const style = getComputedStyle(pane);
          const room =
            pane.clientHeight -
            parseFloat(style.paddingTop) -
            parseFloat(style.paddingBottom);

          /* Tabs in a slide share one scale, taken from whichever is tallest,
             so pressing a pill never resizes the heading, pills, totals or
             cards. Sizing each tab against its own content instead makes the
             whole slide jump the moment a taller tab is opened. */
          const tabs = Array.prototype.slice.call(fitter.querySelectorAll('[data-pane]'));
          const open = tabs.filter((tab) => !tab.hasAttribute('hidden'))[0];
          const height = () => {
            let tallest = fitter.scrollHeight;
            if (!open) return tallest;

            /* Hidden tabs have no box to measure, so each is swapped in
               briefly. The swaps are synchronous, so nothing is painted. */
            tabs.forEach((tab) => {
              if (tab === open) return;
              open.setAttribute('hidden', '');
              tab.removeAttribute('hidden');
              tallest = Math.max(tallest, fitter.scrollHeight);
              tab.setAttribute('hidden', '');
            });
            open.removeAttribute('hidden');
            return tallest;
          };

          fitter.style.setProperty('--gc-fit', '1');
          fitter.style.marginBottom = '';
          pane.classList.remove('is-scrolling');
          if (room <= 0 || height() <= room) return;

          /* Each pass measures the height the previous scale produced, so the
             estimate improves as the cards re-wrap into the widened box. */
          let scale = 1;
          for (let pass = 0; pass < 3; pass++) {
            const target = Math.max(MIN_FIT, Math.min(1, room / height()));
            if (Math.abs(target - scale) < 0.005) break;
            scale = target;
            fitter.style.setProperty('--gc-fit', String(scale));
          }

          /* Easing the scale back up can push the content over again, so the
             last word goes to a pass that is only ever allowed to shrink. */
          if (height() * scale > room) {
            scale = Math.max(MIN_FIT, room / height());
            fitter.style.setProperty('--gc-fit', String(scale));
          }

          /* A transform leaves the original height in the layout, which would
             let the pane scroll to blank space or jump when a control near the
             bottom takes focus. The negative margin removes what the scale
             already took off. */
          fitter.style.marginBottom = -Math.round(fitter.scrollHeight * (1 - scale)) + 'px';

          if (height() * scale > room) {
            pane.classList.add('is-scrolling');
            markPaneEnd(pane);
          }
        });
      }

      /* The header above the section settles late (webfonts, announcement
         bar), so the first measurement is repeated once layout is stable. */
      remeasure() {
        this.measure();
        window.requestAnimationFrame(() => this.measure());
        if (document.readyState !== 'complete') {
          window.addEventListener('load', () => this.measure(), { once: true });
        }
      }

      sync() {
        if (this.media.matches) this.build();
        else this.teardown();
      }

      plan() {
        const form = this.querySelector('.grid-cart__layout');
        if (!form) return [];

        const main = form.querySelector('.grid-cart__main');
        const side = form.querySelector('.grid-cart__side');
        if (!main || !side) return [];

        const account = side.querySelector('.grid-cart__account');
        const root = this.closest('[data-grid-cart]');
        /* Members already have an account and the discount it earns them, so
           the card has nothing left to ask for and is left out. */
        const member = !!(root && root.hasAttribute('data-member'));
        /* The booking slide carries everything about this booking: the grid,
           the slim membership strip and, under it, the compact sign-in row.
           The second slide is only upsells, with the assurance notes under
           them when the shop shows those on phones. The order-summary card
           stays in the sidebar for desktop; phones read the total off the
           sticky checkout bar instead. */
        const groups = [
          {
            label: this.dataset.labelBooking,
            nodes: [
              main.querySelector('.grid-cart__panel'),
              main.querySelector('.grid-cart__member'),
              member ? null : account
            ]
          },
          {
            label: this.dataset.labelExtras,
            nodes: [
              main.querySelector('.grid-cart__addons'),
              this.querySelector('.grid-cart__assurances')
            ]
          }
        ];

        /* A node switched off for phones (the assurance notes can be) is
           still in the document, so it is skipped here rather than given a
           slide that would render empty. */
        const shown = (node) => node && getComputedStyle(node).display !== 'none';

        return groups
          .map((group) => ({ label: group.label, nodes: group.nodes.filter(shown) }))
          .filter((group) => group.nodes.length > 0);
      }

      build() {
        if (this.view) return;

        const form = this.querySelector('.grid-cart__layout');
        const groups = this.plan();
        if (!form || groups.length === 0) return;

        const root = this.closest('[data-grid-cart]');
        const prefix = 'grid-cart-page-' + (root ? root.dataset.sectionId : 'cart');

        const view = document.createElement('div');
        view.className = 'grid-cart__view';

        const track = document.createElement('div');
        track.className = 'grid-cart__track';
        view.appendChild(track);

        this.moved = [];
        this.labels = [];
        this.fitters = [];
        this.panes = groups.map((group, index) => {
          const pane = document.createElement('section');
          pane.className = 'grid-cart__page-pane';
          pane.id = prefix + '-' + index;
          pane.setAttribute('role', 'group');
          pane.setAttribute('aria-label', group.label);

          const fitter = document.createElement('div');
          fitter.className = 'grid-cart__fit';

          group.nodes.forEach((node) => {
            this.moved.push({ node: node, parent: node.parentNode, next: node.nextSibling });
            fitter.appendChild(node);
          });

          pane.appendChild(fitter);
          pane.addEventListener('scroll', () => markPaneEnd(pane), { passive: true });
          track.appendChild(pane);
          this.labels.push(group.label);
          this.fitters.push(fitter);
          return pane;
        });

        /* A card with no slide still sits in the document, so it is hidden
           rather than left to render on its own under the pager. */
        this.stashed = Array.prototype.filter.call(
          form.querySelectorAll('.grid-cart__account'),
          (el) => !el.closest('.grid-cart__page-pane')
        );
        this.stashed.forEach((el) => {
          el.hidden = true;
        });

        this.emptied = [
          form.querySelector('.grid-cart__main'),
          form.querySelector('.grid-cart__side')
        ].filter((el) => {
          if (!el) return false;
          const leftover = Array.prototype.filter.call(el.children, (child) => {
            return !child.hidden && !child.classList.contains('grid-cart__summary');
          });
          return leftover.length === 0;
        });
        this.emptied.forEach((el) => {
          el.hidden = true;
        });

        const indicator = document.createElement('div');
        indicator.className = 'grid-cart__ind';

        const here = document.createElement('p');
        here.className = 'grid-cart__here';
        here.setAttribute('aria-live', 'polite');

        const dotrow = document.createElement('div');
        dotrow.className = 'grid-cart__dotrow';
        if (this.dataset.panesLabel) dotrow.setAttribute('aria-label', this.dataset.panesLabel);

        this.dots = this.panes.map((pane, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', this.labels[index]);
          dot.setAttribute('aria-controls', pane.id);
          dot.addEventListener('click', (event) => {
            /* detail is 0 for keyboard presses, which never end a swipe. */
            if (this.swiped && event.detail > 0) return;
            this.go(index, true);
          });
          dotrow.appendChild(dot);
          return dot;
        });

        const hint = document.createElement('p');
        hint.className = 'grid-cart__swipe';
        hint.innerHTML = SWIPE_ICON;
        if (this.dataset.swipeHint) hint.appendChild(document.createTextNode(this.dataset.swipeHint));

        indicator.appendChild(here);
        indicator.appendChild(dotrow);
        indicator.appendChild(hint);
        /* With nothing to swipe to, the bar would only promise a second page
           that is not there. */
        indicator.hidden = this.panes.length < 2;

        const box = document.createElement('div');
        box.className = 'grid-cart__pagerbox';
        box.appendChild(view);
        box.appendChild(indicator);

        const bar = form.querySelector('.grid-cart__bar');
        form.insertBefore(box, bar);

        this.view = view;
        this.track = track;
        this.here = here;
        this.box = box;
        this.remeasure();

        dotrow.addEventListener('keydown', (event) => this.onKeydown(event));
        view.addEventListener('scroll', () => {
          view.scrollLeft = 0;
          view.scrollTop = 0;
        });
        this.bindSwipe();

        if (window.ResizeObserver) {
          this.observer = new ResizeObserver(() => this.measure());
          this.observer.observe(bar || this);
        }

        this.go(Math.min(lastPane, this.panes.length - 1), false);
      }

      teardown() {
        if (!this.view) return;

        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }

        this.panes.forEach((pane) => {
          pane.inert = false;
        });

        for (let i = this.moved.length - 1; i >= 0; i--) {
          const entry = this.moved[i];
          const anchor = entry.next && entry.next.parentNode === entry.parent ? entry.next : null;
          entry.parent.insertBefore(entry.node, anchor);
        }

        this.emptied.forEach((el) => {
          el.hidden = false;
        });

        this.stashed.forEach((el) => {
          el.hidden = false;
        });

        this.box.remove();

        const root = this.closest('[data-grid-cart]');
        if (root) {
          root.style.removeProperty('--gc-bar-height');
          root.style.removeProperty('--gc-viewport-offset');
          root.removeAttribute('data-app-shell');
        }

        this.moved = [];
        this.panes = [];
        this.dots = [];
        this.fitters = [];
        this.view = null;
        this.track = null;
        this.box = null;
      }

      go(index, moveFocus) {
        const last = this.panes.length - 1;
        const next = Math.max(0, Math.min(last, index));
        const active = document.activeElement;
        const trapped = this.panes.some(
          (pane, i) => i !== next && pane.contains(active)
        );

        const changed = next !== this.index;
        this.index = next;
        lastPane = next;

        this.track.style.transform = 'translateX(-' + next * 100 + '%)';
        this.here.textContent = this.labels[next];

        this.panes.forEach((pane, i) => {
          pane.inert = i !== next;
        });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === next)));

        if (moveFocus || trapped) this.dots[next].focus();
        /* A swipe that springs back lands here too, and must not throw a
           scrolled slide back to its top. */
        if (!changed) return;
        this.panes.forEach((pane) => {
          pane.scrollTop = 0;
          markPaneEnd(pane);
        });
      }

      onKeydown(event) {
        const step = { ArrowRight: 1, ArrowLeft: -1 }[event.key];
        if (!step) return;
        event.preventDefault();
        this.go(this.index + step, true);
      }

      /* The whole pager box listens, so a swipe works on the slides and on
         the BOOKING / dots / SWIPE bar under them alike. Touch pointers stay
         captured to where they went down, so a finger drifting off the bar
         keeps driving the slide. */
      bindSwipe() {
        const track = this.track;
        const surface = this.box;
        let startX = null;
        let delta = 0;
        let width = 1;

        surface.addEventListener('pointerdown', (event) => {
          this.swiped = false;
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          /* The dots fill the middle of the bar, right where a thumb swipes,
             so they start a swipe like the rest of it. A finished swipe sets
             this.swiped, which stops the dot's click from undoing it. */
          const control = event.target.closest('button, a, input, select, textarea, label');
          if (control && !control.closest('.grid-cart__dotrow')) return;
          if (scrollerBetween(event.target, surface)) return;

          startX = event.clientX;
          delta = 0;
          width = track.getBoundingClientRect().width || 1;
          track.classList.add('is-dragging');
        });

        surface.addEventListener('pointermove', (event) => {
          if (startX === null) return;

          delta = event.clientX - startX;
          const atStart = this.index === 0 && delta > 0;
          const atEnd = this.index === this.panes.length - 1 && delta < 0;
          if (atStart || atEnd) delta *= 0.28;

          track.style.transform =
            'translateX(calc(-' + this.index * 100 + '% + ' + delta + 'px))';
        });

        const end = () => {
          if (startX === null) return;

          track.classList.remove('is-dragging');
          const moved = delta;
          startX = null;
          delta = 0;

          this.swiped = Math.abs(moved) > 6;
          const threshold = Math.min(70, width * 0.18);
          if (moved < -threshold) this.go(this.index + 1, false);
          else if (moved > threshold) this.go(this.index - 1, false);
          else this.go(this.index, false);
        };

        surface.addEventListener('pointerup', end);
        surface.addEventListener('pointercancel', end);
      }
    }

    customElements.define('cart-pager', CartPager);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seven-days-products"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('#seven__days__products__swiper', {
    slidesPerView: 8,
    spaceBetween: 20,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      375: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      425: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      640: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 10,
      },
    },
  });

  } catch(e) { console.error(e); }
})();
})();
